import React from 'react';
import {
    QuestionTypeOrder,
    QuestionTypeSelect,
    QuestionTypeConnect,
    QuestionTypeText,
    QuestionTypeNumberScale
} from "../../types/gameSession";
import QuestionOrder from "./QuestionOrder";
import QuestionConnect from "./QuestionConnect";
import QuestionSelect from "./QuestionSelect";
import QuestionText from "./QuestionText";
import QuestionNumberScale from "./QuestionNumberScale";

type Props = {
    question: QuestionTypeSelect | QuestionTypeOrder | QuestionTypeConnect | QuestionTypeText | QuestionTypeNumberScale;
    showPoints: boolean;
    LANG: Record<string, string>;
}

const QuestionContent = ({ question, showPoints, LANG }: Props) => {

    let content;

    switch (question.type) {
        case 'select':
            const selectQuestion = question as QuestionTypeSelect;
            content = <QuestionSelect question={selectQuestion} showPoints={showPoints} />;
            break;
        case 'order':
            const orderQuestion = question as QuestionTypeOrder;
            content = <QuestionOrder question={orderQuestion} showPoints={showPoints} />;
            break;
        case 'connect':
            const connectQuestion = question as QuestionTypeConnect;
            content = <QuestionConnect question={connectQuestion} />;
            break;
        case 'text':
            const textQuestion = question as QuestionTypeText
            content = <QuestionText question={textQuestion} />;
            break;
        case 'number_scale':
            const scaleQuestion = question as QuestionTypeNumberScale;
            const npsScale = scaleQuestion.rating_type === 'nps';
            content = <QuestionNumberScale question={scaleQuestion} npsScale={npsScale} LANG={LANG} />;
            break;
        case 'slide':
            content = '';
            break;
        default:
            content = <div>Unknown question type</div>;
            break;
    }

    return (
        <div className='game-question-content'>
            {content}
        </div>
    )
}

export default QuestionContent;